export class DateHelper {

    private constructor() { }

    static stringToDate(stringDate: string, iwsFormat: string) {
        const m = window.moment(stringDate, this.iwsFormatToMomentJsFormat(iwsFormat));
        return m.toDate();
    }

    static dateToString(date: Date, iwsFormat: string) {
        return window.moment(date).format(this.iwsFormatToMomentJsFormat(iwsFormat));
    }

    static iwsFormatToMomentJsFormat(iwsFormat: string) {
        return iwsFormat.toUpperCase().replace(':MM', ':mm').replace(':SS', ':ss');
    }

    /**
     * Retourne le format d'une date sous forme de string. Les formats utilisés sont définies dans la fonction uiCore.getListFormatDate();
     * @param stringDate
     * @returns
     */
    static getDateFormat(stringDate: string): string {
        const listFormat = uiCore.getListFormatDate();
        for (const format of listFormat) {
            const parsedDate = window.moment(stringDate, format, true)
            if (parsedDate.isValid()) {
                return format
            }
        }
        return ""
    }

    /**
     * retourne un objet date à partir d'une date sous forme de string sans avoir à fournir le format de la date. 
     * Le format de la date doit cependant être dans la liste des formats retournés par uiCore.getListFormatDate();
     * @param stringDate
     * @returns
     */
    static stringToDateAutoFormat(stringDate: string) {
        const listFormat = uiCore.getListFormatDate();
        const dateMoment = window.moment(stringDate, listFormat, true);
        if (dateMoment.isValid()) {
            return dateMoment.toDate();
        }
        return null
    }
}

